export class Market {
  InstrumentID: number;
  SymbolFull: string;
  enable: boolean;
  InstrumentDisplayName: string;
  PriceSource: string;
  TypeId: number;
  Photo: number;
}
